import React, { FC, ReactText, useCallback, useState } from 'react'
import { ISelectOption } from 'components/forms/Selects'
import { SingleSelect } from 'transfix-ui/components/SingleSelect'
import { Box } from 'transfix-ui/core'
import { SortArrowDownIcon } from 'transfix-icons'

const SORTING_OPTIONS = [
  { label: 'Carrier Name', value: 'motorCarrier.name' },
  { label: 'DOT', value: 'motorCarrier.dotNumber' },
  { label: 'MC', value: 'motorCarrier.mcNumber' },
  { label: 'Team Size', value: 'membership.usersCount' },
  { label: 'Date Added', value: 'membership.createdAt' },
]

export interface ICarriersSortingOptions {
  onChange: (selectedOption: string) => void
}

export const CarriersSortingOptions: FC<ICarriersSortingOptions> = ({ onChange: onChangeProp }) => {
  const [selectedOption, setSelectedOption] = useState<string | undefined>(undefined)

  const selectHandler = useCallback(
    (change?: ISelectOption<ReactText> | undefined) => {
      const { value } = change || {}
      setSelectedOption(value as string)
      onChangeProp(value as string)
    },
    [onChangeProp]
  )

  return (
    <Box pt={2}>
      <SingleSelect
        id='carriers-sorting-options'
        dataTest='carriers-sorting-options'
        icon={<SortArrowDownIcon />}
        label='Sort By'
        options={SORTING_OPTIONS}
        onSelect={selectHandler}
        selected={selectedOption}
      />
    </Box>
  )
}
